import React from 'react';

import { Box } from '@lightspeed/flame/Core';
import { IconInfo } from '@lightspeed/flame/Icon/Info';

import { PaymentRequestListingLinkContainer } from 'root/apps/QuoteMachineIntegration/components/PaymentRequest/TotalsSection/styles';

type Props = {
  pendingAmountTotal: string;
  onRegisterPage?: boolean;
};

export const PaymentRequestListingLink: React.FC<Props> = ({
  pendingAmountTotal,
  onRegisterPage = false,
}) => {
  return (
    <PaymentRequestListingLinkContainer>
      <Box style={{ flexShrink: 0, display: 'flex' }}>
        <IconInfo />
      </Box>
      <span
        style={{
          fontSize: '14px',
          lineHeight: '1.4',
          textAlign: onRegisterPage ? undefined : 'left',
        }}
      >
        <var className="notranslate">{pendingAmountTotal}</var> request awaiting payment.{' '}
        <a
          href="/customers/payment-requests"
          style={{ textDecoration: 'underline', color: 'inherit' }}
        >
          View requests
        </a>
      </span>
    </PaymentRequestListingLinkContainer>
  );
};
